import { useState } from 'react';

interface Props {
  onSave: (name: string, summary: string) => void;
  onCancel: () => void;
  saving?: boolean;
}

export function SaveSnapshotDialog({ onSave, onCancel, saving }: Props) {
  const [name, setName] = useState('');
  const [summary, setSummary] = useState('');

  return (
    <div
      style={{
        position: 'fixed', inset: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(0,0,0,0.6)', zIndex: 1000,
      }}
      onClick={onCancel}
    >
      <div
        style={{
          background: 'var(--color-surface, #1a1b1e)', padding: 24,
          borderRadius: 12, maxWidth: 420, width: '90%',
          border: '1px solid rgba(255,255,255,0.1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ fontFamily: 'var(--font-heading)', marginBottom: 16 }}>
          Save Version
        </h3>

        <label style={{ display: 'block', fontSize: 12, color: 'var(--color-text-muted)', marginBottom: 4 }}>
          Version Name (optional)
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Baseline scenario"
          autoFocus
          style={{
            width: '100%', padding: '8px 10px',
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 6, color: 'var(--color-text)',
            fontSize: 13, marginBottom: 12,
            fontFamily: 'var(--font-body)',
            boxSizing: 'border-box',
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !saving) onSave(name, summary);
          }}
        />

        <label style={{ display: 'block', fontSize: 12, color: 'var(--color-text-muted)', marginBottom: 4 }}>
          Change Summary (optional)
        </label>
        <textarea
          value={summary}
          onChange={(e) => setSummary(e.target.value)}
          placeholder="What changed since the last version?"
          rows={3}
          style={{
            width: '100%', padding: '8px 10px',
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: 6, color: 'var(--color-text)',
            fontSize: 13, marginBottom: 16, resize: 'vertical',
            fontFamily: 'var(--font-body)',
            boxSizing: 'border-box',
          }}
        />

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            disabled={saving}
            style={{
              padding: '8px 16px', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 6, background: 'transparent', color: 'var(--color-text)',
              fontSize: 13, cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(name, summary)}
            disabled={saving}
            style={{
              padding: '8px 16px', border: 'none',
              borderRadius: 6, background: 'var(--color-primary)', color: '#fff',
              fontWeight: 600, fontSize: 13, cursor: saving ? 'wait' : 'pointer',
              opacity: saving ? 0.7 : 1,
            }}
          >
            {saving ? 'Saving...' : 'Save Version'}
          </button>
        </div>
      </div>
    </div>
  );
}
